import {NgModule} from '@angular/core';
import {EntriesPipe} from './entries/entries.pipe';
import {KeyPipe} from './keys/key/key.pipe';
import {KeysPipe} from './keys/keys.pipe';
import {StartsWithPipe} from './starts-with/starts-with.pipe';
import {ValuePipe} from './values/value/value.pipe';
import {ValuesPipe} from './values/values.pipe';
import {SortPipe} from './sort/sort.pipe';
import {ExcludesPipe} from './excludes/excludes.pipe';
import {IncludesPipe} from './includes/includes.pipe';
import {QueryPipe} from './query/query.pipe';

@NgModule({
    declarations: [
        EntriesPipe,
        ExcludesPipe,
        IncludesPipe,
        KeyPipe,
        KeysPipe,
        QueryPipe,
        SortPipe,
        StartsWithPipe,
        ValuePipe,
        ValuesPipe
    ],
    exports: [
        EntriesPipe,
        ExcludesPipe,
        IncludesPipe,
        KeyPipe,
        KeysPipe,
        QueryPipe,
        SortPipe,
        StartsWithPipe,
        ValuePipe,
        ValuesPipe
    ],
    imports: []
})
export class PipesModule {
}
